const endPointConfig = {
  endPointURL: process.env.ENDPOINT_URL,
  endPointURI: process.env.ENDPOINT_URI
};

export default endPointConfig;


// WEBPACK FOOTER //
// ./src/endpoint/endpoint.js